import styled from 'styled-components'

export const ProductZoomedImageDiv = styled.div`
  position: absolute;
  z-index: 999;
  overflow: hidden;

  img {
    object-fit: contain;
  }
`

export const ProductHead = styled.div`
  display: grid;
  width: 100%;
  background-color: white;
  padding-bottom: 50px;
  padding: 15px;
  box-sizing: border-box;

  @media screen and (min-width: 1100px) {
    grid-template-columns: 3fr 2fr 1fr;
    grid-gap: 50px;
    padding: 0px;
    padding-bottom: 8px;
  }
`

export const ProductInfo = styled.div`
  position: relative;
  @media screen and (min-width: 1100px) {
    display: flex;
    flex-direction: column;
  }
`

export const ReportDiv = styled.div`
  font-size: 14px;
  order: 7;
  cursor: pointer;
  text-decoration: none;
  color: #808080;
  margin-top: -30px;
  display: flex;
  margin-left: 15px;
  align-items: center;

  p {
    margin-left: 10px;

    @media screen and (min-width: 1100px) {
      max-width: 200px;
    }
  }
`
export const ProductActions = styled.div`
  border: 1px solid #d9d9d9;
  background-color: #f7fafc;
  border-radius: 10px;
  box-sizing: border-box;
  width: 100%;

  .buy-title {
    padding: 10px;
    font-size: 16px;
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.grey2};
    font-weight: normal;
  }

  @media screen and (min-width: 1100px) {
    width: 334px;
  }
`

export const FooterProductActions = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
  border-top: 1px solid #d9d9d9;
  background-color: white;
  box-sizing: border-box;
  width: 100vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 90px;

  .sidebar-price {
    margin: 0 !important;
    padding: 0 !important;
  }

  h2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .saled {
      margin: 0 !important;
      font-size: 24px !important;
    }
    .original {
      margin: 0 !important;
      font-size: 20px !important;
    }
  }

  .buy {
    font-size: 16px;
    font-family: ${props => props.theme.font.family.medium};
    color: white;
    font-weight: normal;
    height: 50px;
    padding: 10px 40px;
    border-radius: 10px;
    background-color: ${props => props.theme.color.red2};
    display: flex;
    align-items: center;
    @media screen and (max-width: 440px) {
      margin-right: 20px;
    }
    @media screen and (max-width: 380px) {
      margin-right: 40px;
    }
  }
`

export const FooterBuyActions = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
  border-top: 1px solid #d9d9d9;
  background-color: white;
  box-sizing: border-box;
  width: 100vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 90px;

  .sidebar-price {
    margin: 0 !important;
    padding: 0 !important;
  }

  h2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .saled {
      margin: 0 !important;
      font-size: 24px !important;
    }
    .original {
      margin: 0 !important;
      font-size: 20px !important;
    }
  }

  .buy {
    font-size: 16px;
    font-family: ${props => props.theme.font.family.medium};
    color: white;
    font-weight: normal;
    height: 50px;
    padding: 10px 40px;
    border-radius: 10px;
    background-color: ${props => props.theme.color.red2};
    display: flex;
    align-items: center;
    @media screen and (max-width: 440px) {
      margin-right: 20px;
    }
    @media screen and (max-width: 380px) {
      margin-right: 40px;
    }
  }
`

export const ProductService = styled.div`
  padding: 10px;

  p {
    color: #1a2738;
    font-size: 14px;
  }

  .storage {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    span {
      font-size: 14px;
      color: #1a2738;
    }

    .out-of-stock {
      color: ${props => props.theme.color.error};
      font-size: 15pt;
    }

    .check-amount-stock {
      color: ${props => props.theme.color.orange};
    }
  }

  .delivery {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    svg {
      margin-right: 12px;
    }

    span {
      color: #1a2738;
      font-size: 14px;
    }
  }

  .garanty {
    margin-top: 15px;
    display: flex;
    align-items: center;

    svg {
      margin-right: 12px;
    }
  }

  .green {
    color: #5ab20a !important;
  }

  @media screen and (min-width: 1100px) {
  }
`

export const ProductActionInputs = styled.div`
  padding: 10px;

  label {
    i {
      width: 21px;
      height: 21px;
    }

    &:not(:first-child) {
      margin-top: 18px;
    }
  }

  @media screen and (min-width: 1100px) {
  }
`

export const ProductActionButtons = styled.div`
  padding: 0px 24px 12px 24px;

  .orange-button {
    margin-top: 10px;
    font-size: 16px;
    width: 100%;
    font-family: ${props => props.theme.font.family.medium};
  }

  .add-cart {
    background-color: #dfe3e9;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    width: 100%;
    font-size: 16px;
    font-family: ${props => props.theme.font.family.regular};
    color: #141414;

    svg {
      margin-right: 10px;
    }
  }

  @media screen and (min-width: 1100px) {
  }
`
export const ProductMetaTop = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media screen and (min-width: 1100px) {
    margin-bottom: 10px;
  }
  @media screen and (max-width: 1100px) {
    justify-content: start;
    flex-direction: row;
  }
`

export const ProductType = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background-color: #f2f4f5;
  width: fit-content;
  border-radius: 10px;
  margin-bottom: 10px;

  a {
    font-size: ${props => props.theme.font.size.sm};
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black2};
    display: flex;
    align-items: center;

    &.firm {
      color: ${props => props.theme.color.blue1};
    }
  }
  img {
    height: 25px;
    object-fit: contain;
    margin-right: 8px;
  }

  @media screen and (min-width: 1100px) {
  }
  @media screen and (max-width: 1100px) {
    margin-right: 20px;
  }
`
export const ProductTitle = styled.h2`
  font-size: 20px;
  font-family: ${props => props.theme.font.family.medium};
  color: ${props => props.theme.color.black2};
  @media screen and (max-width: 768px) {
    font-size: 17px;
  }
`
export const ProductRating = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  margin-bottom: 10px;

  .rating-div {
    display: flex;
    align-items: center;
    margin-right: 15px;
    column-gap: 8px;
  }

  p {
    font-size: ${props => props.theme.font.size.sm};
    color: ${props => props.theme.color.grey2};
    margin-right: 0px;
    margin-left: 7px;

    &:first-child {
      margin-left: 0px;
    }

    span {
      color: ${props => props.theme.color.grey2};
    }
  }
`
export const ProductVersionsContainer = styled.div`
  display: flex;
  margin-top: 20px;
  flex-direction: column;

  h4 {
    font-size: ${props => props.theme.font.size.sm};
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black2};
    margin-bottom: 8px;
    font-weight: normal;
  }

  div {
    margin-bottom: 8px;
  }

  @media screen and (min-width: 1100px) {
  }
`

export const ProductColorCircle = styled.button`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  outline: none;
  background-color: white;
  border: 5px solid ${props => props.color};
  @media screen and (min-width: 1100px) {
  }
`
export const ProductVersions = styled.div`
  column-gap: 8px;
  flex-wrap: wrap;
  display: flex;
  row-gap: 8px;

  h4 {
    font-size: ${props => props.theme.font.size.sm};
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black2};
    margin-bottom: 15px;
    font-weight: normal;
  }

  @media screen and (min-width: 1100px) {
  }
`

export const ProductColor = styled.div`
  display: flex;

  button {
    &:not(:first-child) {
      margin-left: 16px;
    }
  }

  @media screen and (min-width: 1100px) {
  }
`
export const ProductPrice = styled.div`
  margin-top: 5px;

  h4 {
    font-size: ${props => props.theme.font.size.sm};
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black2};
    margin-bottom: 8px;
    font-weight: normal;
  }

  h3 {
    font-size: 18px;
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black};
    margin-bottom: 8px;

    span {
      font-size: 20px;
      font-family: ${props => props.theme.font.family.medium};
      color: ${props => props.theme.color.blue1};
      font-weight: bold;
    }
  }

  .right-installment {
    font-size: 20px !important;
  }
  .right-installment-num {
    font-size: 30px !important;
  }

  .priceMain {
    font-family: ${props => props.theme.font.family.medium};
    font-weight: bolder;
  }

  .sale-badge {
    display: flex;
    align-items: center;
    font-weight: 700;
    text-decoration: none !important;
    -webkit-text-decoration: none !important;
    font-size: 14px;
    color: #fff;
    background: red;
    padding: 5px 6px;
    border-radius: 6px;
    white-space: pre;
    margin-left: 8px;
  }

  h2 {
    margin: 0px;
    display: flex;
    align-items: center;

    .saled {
      font-size: 40px;
      color: ${props => props.theme.color.red};
      font-family: ${props => props.theme.font.family.medium};
      font-weight: bold;

      .balls {
        /* font-size: 13pt; */
      }

      .currency {
        margin-right: 8px;
      }
    }

    .original {
      text-decoration: line-through;
      margin-left: 16px;
      font-weight: bold;
      font-size: 20px;
      color: ${props => props.theme.color.grey1};
      font-family: ${props => props.theme.font.family.medium};
      display: inline-flex;
      align-items: center;

      .price {
        color: #5a6679;
      }

      img {
        margin-right: 10px;
      }
    }
  }

  &.sidebar-price {
    padding: 0px 24px;

    h3 {
      font-size: 18px;
      color: #1a2738;
    }
  }

  @media screen and (min-width: 1100px) {
    order: 1;
  }
`
export const ProductAttributes = styled.div`
  margin-top: 30px;

  h4 {
    font-size: ${props => props.theme.font.size.sm};
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black2};
    margin-bottom: 10px;
    font-weight: normal;
  }

  ul {
    list-style: none;
    margin: 0px;

    li {
      display: flex;
      align-items: center;
      font-size: 14px;
      list-style-type: none;
      color: ${props => props.theme.color.grey2};
      width: 100%;
      position: relative;

      p {
        margin-left: 7px;
      }

      &:not(:first-child) {
        margin-top: 7px;
      }
    }
  }

  a {
    width: fit-content;
    font-size: 14px;
    text-decoration: none;
    color: #1088f8;
    margin-top: 30px;
    margin-bottom: 10px;
    display: block;
    padding: 13px;
    border: 1px solid #1088f8;
    border-radius: 6px;
  }

  @media screen and (min-width: 1100px) {
    order: 2;
  }
`

export const AttributeCheckbox = styled.div`
  width: 100%;
  padding: 11px 18px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.color.white};
  border: solid 1px #dfe3e9;
  color: ${props => props.theme.color.black4};
  font-size: ${props => props.theme.font.size.sm};
  cursor: pointer;
  height: 100%;
`

export const AttributeCheckboxes = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  margin-top: 20px;

  input {
    display: none;

    &:checked + div {
      color: ${props => props.theme.color.orange};
      background-color: rgba(255, 167, 1, 0.08);
      border-color: #ffa701;
      font-family: ${props => props.theme.font.family.medium};
    }
  }
`
export const DeliveryInfoContainer = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: 10px;
  }

  h2 {
    color: #5fb20a;
    font-family: ${props => props.theme.font.family.medium};
    font-size: 16px;
  }
`

export const WarrantyContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 13px;

  span {
    margin-left: 10px;
  }

  .warranty-length {
    font-family: ${props => props.theme.font.family.medium};
    font-size: 16px;
    color: #1088f8;
  }
`

export const StorageStatusContainer = styled.div`
  margin-bottom: 15px;

  span {
    padding: 8px;
    border-radius: 30px;
    background-color: red;
    display: flex;
    align-items: center;
    width: fit-content;

    svg {
      margin-right: 10px;
    }
  }

  .check-amount-stock {
    background-color: #fff3d4;
    color: #d4a418;
  }

  .check-amount-product-item {
    background-color: #f2f4f5;
    color: black;
  }

  .in-stock {
    background-color: #defac2;
    color: #5fb20a;

    &.blue-background {
      background-color: #1e90ff;
      color: #ffffff !important;
    }
  }

  .out-of-stock {
    color: #eb2f20;
    background-color: #ffd9d6;
  }
`
